/**
 * Revantage APAC's business clock. The backend computes "today" and every deadline in
 * Asia/Shanghai (`modules/rev_apac/clock.py`), so the pages render instants on the
 * same clock and label it.
 */
export const BUSINESS_TIMEZONE = "Asia/Shanghai";
export const BUSINESS_TIMEZONE_LABEL = "UTC+8";

/** Date + time on the business clock for display (no daylight saving to account for). */
export function formatBusinessDateTime(input: Date | string | number, locale?: string): string {
    const d = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(d.getTime())) return "";

    return new Intl.DateTimeFormat(locale, {
        timeZone: BUSINESS_TIMEZONE,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
    }).format(d);
}
